// extracted by mini-css-extract-plugin
module.exports = {"input-range":"-ExJ8cB","input-range__input":"-ZR9yRv","input-range__dec":"_-1vnpxT","input-range__inc":"_-1WuCsy","input-range__input-centered":"_-2uSTqA"};